import type { RootState, MainStoreType, AppDispatch } from '../store/main.store.ts';

export class ReduxStoreUtil {
  private static _instance: ReduxStoreUtil;

  static get instance(): ReduxStoreUtil {
    if (!ReduxStoreUtil._instance) {
      ReduxStoreUtil._instance = new ReduxStoreUtil();
    }
    return ReduxStoreUtil._instance;
  }

  async getRootState(): Promise<RootState> {
    return (await this.getStore()).getState();
  }

  async getDispatch(): Promise<AppDispatch> {
    return (await this.getStore()).dispatch;
  }

  private async getStore(): Promise<MainStoreType> {
    // Using a dynamic import to avoid circular dependency
    // when initializing the root store if a Util uses state and is used in a thunk
    return (await import('../store/main.store.ts')).MainStore;
  }
}

export const getReduxStoreUtil = (): ReduxStoreUtil => ReduxStoreUtil.instance;
